<div *ngIf="vertical" class="d-flex flex-column vertical">
	<!-- we keep the label as the css framework requires it to style it appropriately -->
	<div class="questionText">{{question.display_index}}. {{question.prompt}}</div>
	<div *ngFor="let label of labels" (click)="question.answer = label">
		<input class="form-control form-control-lg" type="radio" value="{{label.id}}" [checked]="question.isAnswer(label)" />
		<label><span>{{label.label}}</span></label>
	</div>
</div>
<div *ngIf="!vertical" 
	class="d-flex flex-lg-row flex-column horizontal border border-top-0 border-left-0 border-right-0">
	<div class="questionText pb-3" [ngClass]="getQuestionTextClasses()">{{question.display_index}}. {{question.prompt}}</div>
	<div class="col-lg-1 text-lg-center border border-top-0 border-bottom-0 pt-3" 
		
		*ngFor="let label of labels; let last = last" (click)="question.answer = label">
		<input class="form-control form-control-lg" type="radio" value="{{label.id}}" [checked]="question.isAnswer(label)" />
		<label>
			<span class="d-lg-none">{{label.label}}</span>
		</label>
	</div>
	<div class="text-lg-center border border-top-0 border-bottom-0 pt-3" 
		[ngClass]="getLabelClasses()">
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/assessments/question/question.component.html